import { render } from "./Rolepermission.vue?vue&type=template&id=6fcbd42e&scoped=true"
import script from "./Rolepermission.vue?vue&type=script&lang=js"
export * from "./Rolepermission.vue?vue&type=script&lang=js"

import "./Rolepermission.vue?vue&type=style&index=0&id=6fcbd42e&scoped=true&lang=scss"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcbd42e"]])

export default __exports__